function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(0.406)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.406)",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7.813)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-441.824H47.84v31.894H0Z",
  transform: "translate(0 441.824)",
  fill: "#ce1126"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0-241.824H47.84v21.263H0Z",
  transform: "translate(0 252.456)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0-41.823H47.84v10.631H0Z",
  transform: "translate(0 63.086)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.387 12.802)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M535.573,253.346a.581.581,0,0,1-.162-.123c-.037-.051-.015-.053.135-.012a.6.6,0,0,0,.617-.1l.152-.128.179.091a.568.568,0,0,0,.234.076.513.513,0,0,0,.233-.3c-.006-.088.068-.066.1.031a.346.346,0,0,1-.217.456.5.5,0,0,1-.31-.033c-.167-.058-.2-.058-.28.007a.634.634,0,0,1-.681.035Z",
  transform: "translate(-521.376 -252.191)",
  fill: "#007a3d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M549.1,241.974a.939.939,0,0,1-.119-.476c.022-.067.045-.08.106-.061.107.033.132.107.116.357C549.186,242,549.156,242.051,549.1,241.974Z",
  transform: "translate(-534.23 -241.429)",
  fill: "#007a3d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278.665,247.423c-.022.153.271.532.4.6-.09.04-.2.022-.283.067-.46.46-2.138,2.1-2.444,2.487.908.018,1.915-.012,2.766-.051,0-.617.584-.649.976-.873.2.317.707.293.77.77v2.054H273.1a1.13,1.13,0,0,1-1.438.873c.234-.245.629-.329.77-.667a2.286,2.286,0,0,0-.469-1.619,2.793,2.793,0,0,0,.829-.435c-.273.829.709.738,1.438.719.025-.281.01-.614-.206-.655a1.988,1.988,0,0,0,.77-.514V251.3c1.733,0,3.6-.013,5.371-.013,0-.349.093-.911-.184-.911s-.012.719-.218.719h-4.147v-.711c.176-.176.155-.161,1.356-1.362C277.086,248.9,277.928,248.138,278.665,247.423Z",
  transform: "translate(-271.66 -247.104)",
  fill: "#007a3d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M598.471,246.867a3.722,3.722,0,0,0,.873.462c-.041.147-.172.2-.206.359v3.132c.4.087.479-.137.668-.257.051.5.371.993.359,1.386h-1.7v-5.084Z",
  transform: "translate(-581.099 -246.578)",
  fill: "#007a3d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M515.988,251.76s.616-.52.616-.54v2.734h.444c0-1.041-.014-2.1-.014-3.066a3.879,3.879,0,0,0,.621-.624v4.9h-3.893c-.057-1.016-.067-2.069,1.117-1.842V252.9c-.036-.071-.1.017-.116-.075.188-.188.252-.236.761-.681,0,.537.009,1.8.009,1.8h.449S515.988,251.83,515.988,251.76Zm-1.461,2.165c.083.125.367.123.354-.088-.048-.173-.421-.107-.354.089Z",
  transform: "translate(-500.875 -249.794)",
  fill: "#007a3d"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.238,
  cy: 0.238,
  r: 0.238,
  transform: "translate(2.145 5.712)",
  fill: "#007a3d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454.482,246.961a3.722,3.722,0,0,0,.873.462c-.041.147-.172.2-.206.359v3.132c.4.087.479-.137.668-.257.051.5.371.993.359,1.386h-1.7Q454.482,249.5,454.482,246.961Z",
  transform: "translate(-444.764 -246.667)",
  fill: "#007a3d"
}))));

function SvgIraq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraq);
export default __webpack_public_path__ + "static/media/iraq.f91fafca.svg";
export { ForwardRef as ReactComponent };